<template>
  <div class="maf-footer">
    <svg-icon name="logo-white" :width="72" :height="57"></svg-icon>
    <div class="hrefs">
      <a :href="termsInfo.href" target="_blank">{{ termsInfo.title }}</a>
      |
      <a :href="privacyInfo.href" target="_blank">{{ privacyInfo.title }}</a>
    </div>
    <div class="copyright">
      {{ copyrightText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MafFooter',
  data() {
    return {
      termsInfo: {
        title: 'Terms of Use',
        href: 'https://missionassetfund.org/terms-of-use/'
      },
      privacyInfo: {
        title: 'Privacy',
        href: 'https://missionassetfund.org/privacy-policy/'
      }
    };
  },
  computed: {
    copyrightText() {
      let currentYear = new Date().getFullYear();
      return 'Copyright © ' + currentYear + ' Mission Asset Fund. All Rights Reserved.';
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.maf-footer {
  padding: 20px 0;
  height: $footer-height;
  background-color: $bg-color-footer;
  @include inline-flex-col;
  justify-content: center;
  align-items: center;
  color: $font-color-white;
  font-size: $font-size-small;
  font-weight: normal;
  line-height: $font-size-base;
  text-align: center;

  .icon {
    margin-bottom: 15px;
  }

  a {
    color: $font-color-white;
  }

  .copyright {
    padding: 0 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home-layout/MafFooter.vue